const columnsDataComplex = [
  {
    Header: "Intervenant",
    accessor: "ambulancier",
  },
  {
    Header: "Type Ambulance",
    accessor: "type_ambulance",
  },

  {
    Header: "État Mission",
    accessor: "etat_mission",
  },
  {
    Header: "Date Mission",
    accessor: "date_mission",
  },
  {
    Header: "créé le",
    accessor: "créé_le",
  },
  {
    Header: "Statut",
    accessor: "statut",
  },
  {
    Header: "Start Mission",
    accessor: "start_mission",
  },
  {
    Header: "Numéro",
    accessor: "num",
  },
  {
    Header: "Actions",
    accessor: "actions",
  },
];

export { columnsDataComplex }; 